export default __webpack_public_path__ + "static/media/hht1_ep02_timeline_q04_a.f0cc8432.png";